import { Stack, Typography, useTheme } from "@mui/material";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";
import type { GetTaskWorkflowStepResponse } from "web_myplann/Infrastructure/Api/Api";
import { Step } from "web_myplann/Shared/Components/Step";

type Props<T extends GetTaskWorkflowStepResponse> = {
	name: string;
	steps: T[];
};

export const Steps = <T extends GetTaskWorkflowStepResponse>({
	name,
	steps,
}: Props<T>) => {
	const theme = useTheme();
	const [open, setOpen] = useState(true);

	const Icon = open ? ChevronUp : ChevronDown;

	return (
		<Stack direction="column">
			<Stack
				direction="row"
				padding="8px 0"
				minHeight={40}
				gap={1.6}
				alignItems="center"
			>
				<Stack>
					<Icon
						color={theme.palette.deprecated.grey[400]}
						onClick={() => setOpen((val) => !val)}
						cursor="pointer"
					/>
				</Stack>
				<Typography
					fontSize={14}
					fontWeight={700}
					color={theme.palette.deprecated.grey[700]}
					sx={{
						overflow: "hidden",
						textOverflow: "ellipsis",
						display: "-webkit-box",
						WebkitLineClamp: 2,
						WebkitBoxOrient: "vertical",
						flex: 1,
					}}
				>
					{name}
				</Typography>
			</Stack>
			{open && (
				<Stack position="relative">
					{steps.map((step, i) => (
						<Step
							key={step.taskWorkflowStepID}
							first={i === 0}
							last={i === steps.length - 1}
							data={step}
						/>
					))}
				</Stack>
			)}
		</Stack>
	);
};
